'use strict';
(function($){
	$.validator.methods.email = function( value, element ) {
		return this.optional( element ) || /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/.test( value );
	}
	class ThemeFront {
		constructor() {
			this.preloadImages();
			this.setupHeader();
			this.setupHeroSlider();
			this.setupContent();
			this.setupAJAXpagination();
			this.setupPostsFilters();
			this.handleAccessForms();
			this.handleCookiebot();
		}
		/**
		 * Preload images
		 */
		preloadImages() {
			const srcs = [],
			images = [];
			$('[data-preload]').each( function( i ) {
				const $el = $(this),
				preload = $el.data('preload').split(',');
				$(preload).each( function( j, attr ) {
					const src = $el.data( attr );
					if( srcs.indexOf( src ) == -1 ) {
						images.push( new Image() );
						images[images.length - 1].src = src;
					}
					srcs.push( src );
					
				});
			});
		}
		/**
		 * Setup header
		 */
		setupHeader() {
			// main menu items style
			$('#header li.button-blue, #header li.button-yellow, #header li.button-orange').prev('li.menu-item').addClass('last');
			$('#header .menu > li.menu-item').on( 'mouseenter', function() {
				$(this).prev('li.menu-item').addClass('hovered');
			}).on( 'mouseleave', function() {
				$(this).prev('li.menu-item').removeClass('hovered');
			});
			// header search
			$('#header-search-toggle').on( 'click', function( e ) {
				e.preventDefault();
				if( $(window).width() < 1170 ) {
					$(this).parents('#main-nav').addClass('is-search');
				} else {
					$(this).parents('.header-search').find('.search-form').addClass('open');
					$('#main-nav .search-field').focus();
				}
				
			});
			$('#header .header-search-close').on( 'click', function( e ) {
				e.preventDefault();
				$(this).parents('.header-search').find('.search-form').removeClass('open');
			});
			// mobile menu toggler
			$('#mobile-menu-toggler, #header-close-mobile').on( 'click', function( e ) {
				e.preventDefault();
				$( 'body').toggleClass( 'is-menu-open');
				if( $('#main-nav').hasClass('is-search') ) {
					$('#main-nav').removeClass('is-search');
				}
			}); 
			$( document ).click( function( e ) {
				if( $( e.target).closest( '#header .menu, #mobile-menu-toggler, #main-nav').length === 0) {
					$('body').removeClass('is-menu-open');
					if( $('#main-nav').hasClass('is-search') ) {
						$('#main-nav').removeClass('is-search');
					}
				}
			});
			// mobile toggle menu items
			$('#header .menu > .menu-item-has-children > a').on( 'click', function( e ) {
				if( $(window).width() < 1170 ) {
					e.preventDefault();
					$(this).parent().toggleClass('is-open');
				}
			});
			// header search
			$('#header .search-field').on( 'keyup', function() {
				const $el = $(this),
				$submit = $el.next('input[type=submit]');
				if( $(window).width() < 1170 ) {
					$.trim( $el.val() ) != '' ? $submit.show() : $submit.hide();
				}
			});
		}
		/**
		 * Page hero slider
		 */
		setupHeroSlider() {
			const switchHeaderStyle = function( theme ) {
				const $header = $('#header'),
				$logo = $('#header .header-logo img'),
				$socialIcons = $('#header .social-profiles img'),
				isMobile = $(window).width() <= 1169;
				if( theme == 'dark' ) {
					$header.addClass('style-dark').removeClass('style-white');
					$logo.attr( 'src', $logo.attr('data-dark-logo') );
					if( ! isMobile ) {
						$socialIcons.each( function() {
							const $img = $(this);
							$img.attr('src', $img.attr('data-src-dark') );
						});
					}
				} else {
					$header.addClass('style-white').removeClass('style-dark');
					$logo.attr( 'src', $logo.attr('data-white-logo') );
					if( ! isMobile ) {
						$socialIcons.each( function() {
							const $img = $(this);
							$img.attr('src', $img.attr('data-src-white') );
						});
					}
				} 
				if( isMobile ) {
					$socialIcons.each( function() {
						const $img = $(this);
						$img.attr('src', $img.attr('data-src-white') );
					});
				}
			}
			if( $('body').hasClass('page-template-page-tpl-where-we-operate')) {
				switchHeaderStyle('dark');
			}
			const $hero = $('.hero-slider');
			if( ! $hero.length ) {
				return;
			}
			const $slider = $hero.slick({
				dots: false,
				arrows: false,
				fade: true,
				cssEase: 'linear',
				autoplay: true
			});
			const checkHeaderStyle = function( $currentSlide ) {
				let theme = '';
				if( $currentSlide.hasClass('style-white') ) {
					theme = 'white';
				} else {
					theme = 'dark';
				}
				switchHeaderStyle( theme );
				
			}
			checkHeaderStyle( $('.hero-slider .slick-slide:first') );
			$slider.on( 'afterChange', function( event, slick, currentSlide, nextSlide){
				const $slide = $('.hero-slider .slick-slide').eq( currentSlide );
				checkHeaderStyle( $slide );
			});
		}
		/**
		 * Setup content
		 */
		setupContent() {
			// responsive tables
			$('table').not('.props-table, .rating-table').wrap('<div class="responsive-table"></div>');
			// addthis callback
			if( window.addthis ) {
				window.addthis.addEventListener( 'addthis.ready', function() {
					
					$('.share-box').addClass('loaded');
				});
			}
			// custom select inputs
			$('select').not('#country-filter').selectric({
				maxHeight: 150
			});
			$('#country-filter').select2({
				placeholder: 'Select your country',
				width: '100%'
			});
			// min height for some blocks
			$('.block-card-links, .block-card-links-v2').each( function() {
				const $block = $(this),
				$thumb = $block.find( '.post-thumb'),
				imgHeight = $thumb.outerHeight(),
				textHeight = $block.find( '.post-details').outerHeight();
				if( textHeight > imgHeight ) {
					$thumb.css('min-height', (textHeight + 120) + 'px' );
				}
			});
		}
		/**
		 * AJAX pagination
		 */
		setupAJAXpagination() {
			const self = this;
			$('.ajax-load-more-link').on( 'click', function( e ) {
				e.preventDefault();
				self.loadPosts( false );
			});
		}
		/**
		 * Posts filters
		 */
		setupPostsFilters() {
			const self = this;
			// clear filters
			$('#filters .clear-filters').on( 'click', function( e ) {
				e.preventDefault();
				$('#filters select').val('').selectric('refresh');
				self.loadPosts( true );
			});
			// filter posts
			$('#filters select').on( 'change', function( e ) {
				self.loadPosts( true );
			});
		}
		/**
		 * Load posts
		 */
		loadPosts( again = false ) {
			const $link = $( '#ajax-load-more'),
			$postsHolder = $( $link.data('posts-holder') ),
			$loader = $( $link.data('loader') ),
			$filters = $('#filters');
			if( again ) {
				$link.addClass('is-again');
			}
			const isHeroPost = $('#post-hero').length ? 1 : 0;
			let offset = $postsHolder.find('.post').length;
			if( ! $link.hasClass( 'is-again' ) ) {
				offset = offset + isHeroPost;
			}
			$.ajax({
				url: themeVars.ajaxurl,
				type: 'POST',
				dataType: 'json',
				data: {
					'action' : 'theme_load_posts',
					'nonce' : themeVars.ajaxNonce,
					'load_again' : again,
					'query' : $link.attr('data-current-query'),
					'query_type' : $link.attr('data-query-type'),
					'cols' : $link.attr('data-cols'),
					'filters' : $filters.length ? $filters.serialize() : '',
					'offset' : offset
				},
				beforeSend: function() {
					$postsHolder.addClass('is-loading');
					$loader.addClass('active');
				},
				success: function( answer ) {
					$postsHolder.removeClass('is-loading');
					$loader.removeClass('active');
					if( again ) {
						$postsHolder.html( answer.html );
					} else {
						$postsHolder.append( answer.html );
					}
					$link.attr('data-current-query', JSON.stringify( answer.query ) );
					if( answer.hide_link ) {
						$link.hide();
					} else {
						$link.show();
					}
				}
			});
		}
		/**
		 * Content access forms
		 */
		handleAccessForms() {
			// switch forms
			$('a.switch-form').on( 'click', function( e ) {
				e.preventDefault();
				const $link = $(this),
				$currentForm = $link.parents('form'),
				$targetForm = $( '#' + $link.data( 'to'));
				$currentForm.hide();
				$targetForm.fadeIn('fast');
			});
			// validate forms
			$('#form-login, #form-request-access, #form-forgot-password, #form-change-password').each( function() {
				const $form = $(this),
				formId = $form.attr( 'id'),
				formAction = $form.find('input[name=action]').val(),
				$resultDiv = $form.find('.result'),
				$submit = $form.find( 'button[type=submit]');
				let validationRules = {},
				validationMessages = {
					email: 'Please, enter a valid email address',
					password: 'Please, type your password',
					name: 'Please enter your name',
					password: {
						required: 'Please provide a password',
						minlength: 'Your password must be at least 5 characters long',
					},
					password2: {
						required: 'Passwords must match one another',
						minlength: 'Passwords must match one another',
						equalTo: 'Passwords must match one another'
					}
				};
				switch( formId ) {
					case 'form-login':
						validationRules = {
							email: {
								required: true,
								email: true,
							},
							password: {
								required: true,
								minlength: 5
							}
						};
					break;
					case 'form-request-access':
						validationRules = {
							name: {
								required: true
							},
							email: {
								required: true,
								email: true,
							},
							password: {
								required: true,
								minlength: 5
							},
							password2: {
								required: true,
								minlength: 5,
								equalTo: "#password"
							}
						};
					break;
					case 'form-forgot-password':
						validationRules = {
							email: {
								required: true,
								email: true,
							}
						};
					break;
					case 'form-change-password':
						validationRules = {
							new_password: {
								required: true,
								minlength: 5
							},
							new_password2: {
								required: true,
								minlength: 5,
								equalTo: "#new_password"
							}
						};
					break;
				}
				$form.validate({
					rules: validationRules,
					messages: validationMessages,
					errorElement: 'li',
					errorLabelContainer: '#' + formId + ' .errors ul',
					highlight: function() {
						$resultDiv.html('');
					},
					unhighlight: function() {
						$resultDiv.html('');
					},
					submitHandler: function( form ) {
						const $thisForm = $(form);
						$.ajax({
							url: themeVars.ajaxurl,
							type: 'POST',
							dataType: 'json',
							data: {
								action: formAction,
								data: $thisForm.serialize()	
							},
							beforeSend: function() {
			
								$thisForm.find( '.result').html('');
								$thisForm.addClass( 'is-loading');
			
							},
							success: function( answer ) {
								$thisForm.removeClass( 'is-loading');
								if( answer.success == true && answer.data.refresh ) {
									window.location.reload();
								} else if( answer.success == false ) {
									$thisForm.find( '.result').html( '<p class="error-text">' + answer.data.message + '</p>');
								} else if( answer.success == true ) {
									$thisForm.html( '<p class="success-text">' + answer.data.message + '</p>');
								}
			
							}
						});
						return false;
					}
				});
				$form.find('input').on( 'keyup', function() {
					if( $form.valid() ) {
						$submit.removeAttr( 'disabled');
					} else {
						$submit.attr( 'disabled', 'disabled');
					}
				});
			});
		}

		/**
		 * Show a warning if Cookiebot was not accepted by user
		 */
		handleCookiebot() {

			const $notice = $('#map-cookiebot-notice');

			if (typeof Cookiebot !== 'undefined' && !Cookiebot.consent.preferences) {

				$notice.show();

				// Listen for Cookiebot consent change
				window.addEventListener('CookiebotOnAccept', function() {
					$notice.hide();
				});
			} 

		}

	}
	window.ThemeFront = new ThemeFront();
})( window.jQuery );